import { render, staticRenderFns } from "./_percent.vue?vue&type=template&id=2c8c76d5&scoped=true"
import script from "./_percent.vue?vue&type=script&lang=js"
export * from "./_percent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c76d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8c76d5')) {
      api.createRecord('2c8c76d5', component.options)
    } else {
      api.reload('2c8c76d5', component.options)
    }
    module.hot.accept("./_percent.vue?vue&type=template&id=2c8c76d5&scoped=true", function () {
      api.rerender('2c8c76d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/_percent.vue"
export default component.exports